import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

export class SearchPageInfo {
  RouteName: string;
  Filter: any;
}

@Injectable({
  providedIn: 'root'
})
export class FilterDataService {
  private FilterInfo = new SearchPageInfo();
  private CurrentFilterInfo = this.FilterInfo;
  HasUsed: boolean = false;

  constructor() { }

  GetSearchInfo() {
    this.HasUsed = true;
    return this.CurrentFilterInfo;
  }

  ChangeSearchInfo(RouteName: string, Filter: any) {
    this.HasUsed = false;
    this.FilterInfo.RouteName = RouteName;
    this.FilterInfo.Filter = Filter;
  }
}
